import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ApiService } from "app/shared/services/api.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-client-pipelines-matching-results",
  templateUrl: "./client-pipelines-matching-results.component.html",
  styleUrls: ["./client-pipelines-matching-results.component.scss"],
})
export class ClientPipelinesMatchingResultsComponent implements OnInit {
  matchResult: any = null;
  isConfirming: Record<string, boolean> = {};

  constructor(
    private router: Router,
    private apiService: ApiService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.loadLatestResult();
  }

  get matchedRows(): any[] {
    return this.matchResult?.matchedResult || [];
  }

  loadLatestResult(): void {
    const raw = localStorage.getItem("clientPipelineMatchResult");
    this.matchResult = raw ? JSON.parse(raw) : null;
  }

  goBackToList(): void {
    this.router.navigate(["/client-pipelines"]);
  }

  clearResults(): void {
    localStorage.removeItem("clientPipelineMatchResult");
    this.matchResult = null;
  }

  confirmMerge(item: any): void {
    const pipelineId = item?.pipelineData?._id;
    const clientId = item?.clientData?._id;

    if (!pipelineId || !clientId) {
      this.toastr.error("Missing pipeline or client reference for merge");
      return;
    }

    if (this.isConfirming[pipelineId]) {
      return;
    }

    this.isConfirming[pipelineId] = true;
    this.spinner.show();

    this.apiService.confirmClientPipelineMerge(pipelineId, clientId).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.isConfirming[pipelineId] = false;
        if (res?.statusCode === 200 || res?.isSuccess === true) {
          this.toastr.success(res?.message || "Client pipeline merged successfully");
          this.removeMatchedRow(pipelineId);
        } else {
          this.toastr.error(res?.error || "Unable to complete merge");
        }
      },
      (error) => {
        this.spinner.hide();
        this.isConfirming[pipelineId] = false;
        this.toastr.error(error?.error?.error || "Unable to confirm merge right now");
      }
    );
  }

  private removeMatchedRow(pipelineId: string): void {
    if (!this.matchResult?.matchedResult) {
      return;
    }

    this.matchResult = {
      ...this.matchResult,
      matchedPipeline: Math.max((this.matchResult?.matchedPipeline || 0) - 1, 0),
      matchedResult: this.matchResult.matchedResult.filter(
        (record: any) => record?.pipelineData?._id !== pipelineId
      ),
    };

    localStorage.setItem(
      "clientPipelineMatchResult",
      JSON.stringify(this.matchResult)
    );
  }
}

